import React from "react";
import { useAudioLevels } from "../../hooks/useAudioLevels";

const AudioLevelBar = React.memo(({ recordingState }) => {
  const audioLevel = useAudioLevels(recordingState === "recording");

  return (
    <div class="audio-info">
      <div
        class="audio-level-bar"
        style={{ height: 10, width: 250, borderRadius: 10 }}
      >
        <div
          class="audio-level-fill"
          style={{
            width: `${audioLevel > 100 ? 100 : audioLevel}%`,
            backgroundColor: `rgb(110,117,${255 - audioLevel * 0.255})`,
            height: 10,
            borderRadius: 10,
          }}
        ></div>
      </div>
    </div>
  );
});

export default AudioLevelBar;
